<template>
  <div class="normal-layout-box show-flex-box-c">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Layout",
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.normal-layout-box {
  // display: inline-block;
  width: 100%;
  height: 100%;
  min-height: 100%;
  background: url("../../assets/background/home_background.png") center center no-repeat;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue